(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.talentfunlUtils = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyQueries = applyQueries;
exports.convertToSlug = convertToSlug;
exports.getItemUrl = getItemUrl;
exports.getItemId = getItemId;
exports.getTypeIdField = getTypeIdField;
exports.query = query;
exports.getItems = getItems;
exports.getSingleItem = getSingleItem;
exports.getEmployerNumberJobs = getEmployerNumberJobs;

var _searchkit = (typeof window !== "undefined" ? window['searchkit'] : typeof global !== "undefined" ? global['searchkit'] : null);

var _lodash = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function applyQueries(manager) {
  var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (queries.length == 0) {
    return;
  }

  var applied_queries = [];

  for (var query_index in queries) {
    var query = queries[query_index];
    var query_type = Object.keys(query)[0];
    var query_field = Object.keys(query[query_type])[0];
    var query_value = query[query_type][query_field];

    switch (query_type) {
      case 'match':
        var sk_query = (0, _searchkit.MatchQuery)(query_field, query_value.query);
        break;

      case 'range':
        var sk_query = (0, _searchkit.RangeQuery)(query_field, query_value);
        break;

      case 'terms':
        var sk_query = (0, _searchkit.TermsQuery)(query_field, query_value);
        break;

      default:
        var sk_query = false;
        break;
    }

    if (sk_query) {
      applied_queries.push(sk_query);
    }
  }

  manager.addDefaultQuery(function (query) {
    // @todo support for other query types, like SHOULD, ClickUp ID: #vqj0
    return query.addQuery((0, _searchkit.FilteredQuery)({
      filter: (0, _searchkit.BoolMust)(applied_queries)
    }));
  });
  return manager;
}

function convertToSlug(text) {
  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
}

;

function getItemUrl(item) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'job';
  var id = getItemId(item, type);
  var title;

  if (type == 'job') {
    title = item.positionTitle;
  } else if (type == 'employerprofile') {
    title = item.employerName;
  }

  return ES.item_base_url + id + "/" + convertToSlug(title);
}

;

function getItemId(item) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'job';
  return item[getTypeIdField(type, item)];
}

;

function getTypeIdField() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'job';
  var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (null === item) {
    item = {
      scrapped: false
    };
  }

  if (type == 'job') {
    if (item.scrapped) {
      return 'id';
    } else {
      return 'originalJobId';
    }
  } else if (type == 'employerprofile') {
    return 'employerId';
  }
}

;

function query() {
  var item_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'job';
  var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  var query = new _searchkit.SearchkitManager(ES.elasticsearch[item_type].endpoint, {
    useHistory: false,
    timeout: 10000,
    defaultSize: size
  });
  applyQueries(query, [].concat(_toConsumableArray(ES.elasticsearch[item_type].default_queries), _toConsumableArray(queries)));
  return query.search(false, false);
}

function getItems() {
  var item_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'job';
  var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  return new Promise(function (resolve) {
    query(item_type, queries, size).then(function (results) {
      resolve((0, _lodash.get)(results, ['results', 'hits', 'hits'], []));
    });
  });
}

function getSingleItem() {
  var item_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'job';
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve) {
    query(item_type, [{
      match: _defineProperty({}, getTypeIdField(item_type), {
        query: id
      })
    }], 1).then(function (results) {
      resolve((0, _lodash.get)(results, ['results', 'hits', 'hits', '0', '_source'], null));
    });
  });
}

function getEmployerNumberJobs() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return new Promise(function (resolve) {
    query('job', [{
      match: {
        organizationId: {
          query: id
        }
      }
    }], 1).then(function (results) {
      resolve((0, _lodash.get)(results, ['results', 'hits', 'total'], 0));
    });
  });
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1])(1)
});
